import { Box, Spinner } from '@palmetto/palmetto-components';

import { SabalInternalEvents } from 'types';

import { useGetAllocationsHistoryCursorInfiniteQuery } from '../../services/allocations';
import { InfiniteActivityList } from '../Activity/InfiniteActivityList';

const incentiveTypes = [
  SabalInternalEvents.sabalAllocationCreated,
  SabalInternalEvents.sabalAllocationUpdated,
  SabalInternalEvents.sabalAllocationCompleted,
  SabalInternalEvents.sabalAccountsAssignedToAllocation,
  SabalInternalEvents.sabalAccountsUnassignedFromAllocation,
  SabalInternalEvents.sabalAllocationBlocked,
];

const PAGE_SIZE = 20;

export const IncentiveHistory = () => {
  const { data, fetchNextPage, isLoading, isFetchingNextPage, hasNextPage } =
    useGetAllocationsHistoryCursorInfiniteQuery(PAGE_SIZE, {
      initialPageParam: {
        eventTypes: incentiveTypes,
        limit: PAGE_SIZE,
        cursor: undefined,
      },
    });

  const activities = data?.pages.flatMap((page) => page.data) ?? [];

  return (
    <Box direction="row" childGap="3xl">
      <Box flex="auto">
        {isLoading ? (
          <Spinner size="lg" />
        ) : activities.length > 0 ? (
          <InfiniteActivityList
            activities={activities}
            fetchNextPage={fetchNextPage}
            isLoading={isFetchingNextPage}
            hasMore={hasNextPage ?? false}
          />
        ) : (
          <Box fontSize="sm" color="body-secondary">
            No history exists at the moment.
          </Box>
        )}
      </Box>
    </Box>
  );
};
